export default __webpack_public_path__ + "static/media/icon2.d2a5fb05.png";